import { makeAutoObservable } from 'mobx';

export class Store {
  accountName = '';
  tenantName = '';
  name = '';
  email = '';
  helpRequired = false;
  isGtReseller = false;
  selectedAvailability = null;

  constructor() {
    makeAutoObservable(this);
  }

  initalizeStore() {
    this.accountName = '';
    this.tenantName = '';
    this.name = '';
    this.email = '';
    this.helpRequired = false;
    this.isGtReseller = false;
    this.selectedAvailability = null;
  }

  setAccountName(value) {
    this.accountName = value;
  }

  setTenantName(value) {
    this.tenantName = value;
  }

  setFullName(value) {
    this.name = value;
  }

  setEmail(value) {
    this.email = value;
  }

  setSelectedAvailability(value) {
    this.selectedAvailability = value;
  }

  handleHelpRequiredToggle() {
    this.helpRequired = !this.helpRequired;
  }

  handleGtResellerToggle() {
    this.isGtReseller = !this.isGtReseller;
  }
}
